import {useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setUpdateGroupPayload, selectUpdateGroupPayload} from '../slices/updateProjectSlice'
import {useProjectDetails} from './projectDetails'
import {checkBlankInputCompletedProject} from '../../AdminPanel/ProjectDetails/Helper/UpdateProject'

export const useUpdateProject = () => {
  const dispatch = useDispatch()
  const updateGroupPayload = useSelector(selectUpdateGroupPayload)
  const {updateGroup, error, isCompleted} = useProjectDetails()

  const handleUpdate = useCallback(
    (
      updateDetails,
      handleClickOpen,
      setShowNotification,
      setNavigateToProjectList,
      refetchGroupPermission,
      refetchGroups
    ) => {
      const {
        projectName,
        selectedJurisdiction,
        selectedFilters,
        exit,
        selectedTrendAnalysis,
        selectedExportToggle,
        selectedChatbot,
        selectedPersona,
        updatePayload,
        setInputDisabled
      } = updateDetails
      const selectedOptions = {
        selectedJurisdiction,
        selectedFilters,
        selectedTrendAnalysis,
        selectedExportToggle,
        selectedChatbot,
        selectedPersona
      }
      if (exit && checkBlankInputCompletedProject(isCompleted, projectName, selectedOptions)) {
        dispatch(setUpdateGroupPayload(updatePayload))
        handleClickOpen()
      } else {
        updateGroup({variables: updatePayload}).then(async () => {
          // Refetch data from network to get updated values
          if (refetchGroupPermission) {
            await refetchGroupPermission({fetchPolicy: 'network-only'})
          }
          if (refetchGroups) {
            await refetchGroups({fetchPolicy: 'network-only'})
          }
          setShowNotification(true)
          if (exit && !error) {
            setNavigateToProjectList(true)
          }
          !error && setInputDisabled(true)
        })
      }
    },
    [dispatch, updateGroup, error, isCompleted]
  )

  const saveUpdateProjectDetails = useCallback(
    (setShowNotification, exit, setNavigateToProjectList, setInputDisabled, refetchGroupPermission, refetchGroups) => {
      updateGroup({variables: updateGroupPayload}).then(async () => {
        // Refetch data from network to get updated values
        if (refetchGroupPermission) {
          await refetchGroupPermission({fetchPolicy: 'network-only'})
        }
        if (refetchGroups) {
          await refetchGroups({fetchPolicy: 'network-only'})
        }
        setShowNotification(true)
        if (exit && !error) {
          setNavigateToProjectList(true)
        }
        !error && setInputDisabled(true)
      })
    },
    [updateGroup, updateGroupPayload, error]
  )

  const values = useMemo(
    () => ({
      saveUpdateProjectDetails,
      handleUpdate,
      updateGroupPayload
    }),
    [saveUpdateProjectDetails, handleUpdate, updateGroupPayload]
  )

  return values
}
